import { SubscribtionService } from './../Services/subscribtion.service';
import { AddPremiumAdTokenResponse } from './../app_mobile/api/WickedApiClient';
import { Component, OnInit } from '@angular/core';
import { MainService } from '../Services/service.service';


export enum AdView { Advertisement = 0, Payment = 1 }

@Component({
  selector: 'app-buy-third-party',
  templateUrl: './buy-third-party.component.html',
  styleUrls: ['./buy-third-party.component.scss']
})
export class BuyThirdPartyComponent implements OnInit {

  constructor(public services: MainService, private subscriptionService: SubscribtionService,) { }

  ngOnInit() {

  }
}
